module.exports = __webpack_public_path__ + "assets/img/1201_01.jpg?c573c19409377f93e76b6e8bc5bdfc28";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1201_01.jpg
// module id = 1069
// module chunks = 0